import React from 'react';

function Lock() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 24 24">
      <path d="M21.158 11.386c-.318-.318-.704-.477-1.159-.477h-.545V7.636c0-2.09-.75-3.886-2.25-5.386S13.91 0 11.818 0 7.931.75 6.432 2.25c-1.5 1.5-2.25 3.295-2.25 5.386v3.273h-.546c-.454 0-.84.16-1.159.477-.318.318-.477.705-.477 1.16v9.818c0 .454.16.84.477 1.159.318.318.705.477 1.16.477H20c.454 0 .84-.159 1.159-.477.318-.318.477-.705.477-1.16v-9.818c0-.454-.16-.84-.478-1.159zm-4.976-.477H7.454V7.636c0-1.204.427-2.233 1.279-3.085.852-.852 1.88-1.278 3.085-1.278s2.233.426 3.085 1.278c.852.852 1.279 1.88 1.279 3.085v3.273z" />
    </svg>
  );
  /* eslint-enable */
}

export default Lock;



// WEBPACK FOOTER //
// ./src/common/icons/Lock.js